import { NgModule } from '@angular/core';
import { TimePickerDirective } from '@shared/directives/timePicker.directive';

@NgModule({
  exports: [TimePickerDirective],
  declarations: [TimePickerDirective],
})
export class TimePickerModule {}
